import {
  Component,
} from "react";
import {
  Alert,
  Button,
  Modal,
} from "react-bootstrap";
import {
  Spinner,
} from "CommonComponents/bricks";
import {
  renderChildren,
} from "CommonCore/router-util";

export default class Confirmation extends Component {
  render() {
    const {
      header,
      body,
      action,
      inflight,
      disabled,
      errorMessage,
      onConfirm,
      onCancel,
      extraButtons,
      actionStyle,
    } = this.props;
    return <Modal show onHide={onCancel}>
      <Modal.Header>
        <h2>{header}</h2>
      </Modal.Header>
      <Modal.Body>
        {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
        {body}
        {renderChildren(this.props)}
      </Modal.Body>
      <Modal.Footer>
        { onConfirm &&
                    <Button variant={ actionStyle || "danger"} onClick={onConfirm} disabled={inflight || disabled}>
                      {inflight ? <Spinner /> : action}
                    </Button>
        }
        { extraButtons }
        {onCancel && <Button variant='link' onClick={onCancel} disabled={inflight}>Abbrechen</Button>}
      </Modal.Footer>
    </Modal>;
  }
}
